module.exports = __webpack_public_path__ + "static/media/lumbering21.8cf5cd24.jpg";